export function getRatingIndex(rating: number) {
  const ratingIndesisLength = 5
  if (rating === 100) {
    return ratingIndesisLength - 1 // return maximum index for 100% valid and correct rating
  }
  return Math.floor(rating / (100 / ratingIndesisLength)) // Splits to 5 equal parts and returns index, for the later search in array of ratings
}
